import React from 'react';
import { AppMode } from '../App';
import './Sidebar.css';

interface SidebarProps {
  activeView: string;
  onViewChange: (view: string) => void;
  propertyCount: number;
  brokerCount?: number;
  mode: AppMode;
  onModeChange: (mode: AppMode) => void;
  onLogout?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeView, onViewChange, propertyCount, brokerCount, mode, onModeChange, onLogout }) => {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img src="/ownrly-logo.png" alt="Ownrly" className="sidebar-logo" />
        <div className="mode-toggle">
          <button
            className={`mode-btn ${mode === 'admin' ? 'active' : ''}`}
            onClick={() => onModeChange('admin')}
          >
            Admin
          </button>
          <button
            className={`mode-btn ${mode === 'broker' ? 'active' : ''}`}
            onClick={() => onModeChange('broker')}
          >
            Broker
          </button>
        </div>
      </div>
      <nav className="sidebar-nav">
        {mode === 'admin' ? (
          <>
            <button
              className={`nav-item ${activeView === 'properties' ? 'active' : ''}`}
              onClick={() => onViewChange('properties')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
              <span>Properties</span>
              {propertyCount > 0 && <span className="badge">{propertyCount}</span>}
            </button>
            <button
              className={`nav-item ${activeView === 'upload' ? 'active' : ''}`}
              onClick={() => onViewChange('upload')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
              <span>Import CSV/XLSX</span>
            </button>
            <button
              className={`nav-item ${activeView === 'brokers' ? 'active' : ''}`}
              onClick={() => onViewChange('brokers')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              <span>Brokers</span>
              {(brokerCount ?? 0) > 0 && <span className="badge">{brokerCount}</span>}
            </button>
          </>
        ) : (
          <button
            className={`nav-item ${activeView === 'brokerPortal' ? 'active' : ''}`}
            onClick={() => onViewChange('brokerPortal')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            <span>My Properties</span>
          </button>
        )}
      </nav>
      {onLogout && (
        <div className="sidebar-footer">
          <button className="nav-item logout-btn" onClick={onLogout}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span>Sign out</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
